import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["saveButton"]

  toggleSaveButton(event) {
    const selectionType = event.target.value

    if (!this.hasSaveButtonTarget) return

    if (selectionType === "existing") {
      this.saveButtonTarget.classList.add("hidden")
    } else if (selectionType === "new") {
      this.saveButtonTarget.classList.remove("hidden")
    }
  }
}
